import { createSelector } from 'reselect';

import {
  // Navigation
  navigationHomeArmstrongSelector,
  navigationDiscoverArmstrongSelector,
  navigationMeHubV2ArmstrongSelector,
  navigationJobsArmstrongSelector,
  navigationMenuSelector,
} from '@xingternal/platform-layout-selectors';

const mainListSelector = createSelector(
  navigationHomeArmstrongSelector,
  navigationDiscoverArmstrongSelector,
  navigationMeHubV2ArmstrongSelector,
  navigationJobsArmstrongSelector,
  navigationMenuSelector,
  (home, discover, meHubV2, jobs, menu) => {
    return {
      navigationItems: [home, discover, meHubV2, jobs, menu],
    };
  }
);

export { mainListSelector };
